import { cnHeader, Header, HeaderProps } from '@/blocks/header'

export function HeaderDefault({ children, className }: HeaderProps): JSX.Element {
  return <Header className={cnHeader({ default: true }, [className])}>{children}</Header>
}
